import { Modal } from 'bootstrap'

function handleVideoModalEvents() {
  const videoModalElement = document.getElementById('videoModal')
  const videoModalContentElement = document.getElementById('videoModalContent')

  if (videoModalElement && videoModalContentElement) {
    // Pre-instantiate the Modal so Bootstrap's internal _config is set before any trigger fires
    new Modal(videoModalElement)

    videoModalElement.addEventListener('show.bs.modal', (event: MouseEvent) => {
      const relatedTarget = event.relatedTarget as HTMLElement
      switch (relatedTarget.dataset.videoHost) {
        case 'youtube':
          if (relatedTarget.dataset.videoPlaylist === "true") {
            videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/videoseries?list=${relatedTarget.dataset.videoId}&controls=1&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
          } else {
            videoModalContentElement.innerHTML = `<iframe src="https://www.youtube.com/embed/${relatedTarget.dataset.videoId}?controls=1&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
          }
          break
        default:
          console.warn(`Video host '${relatedTarget.dataset.videoHost}' not supported.`)
          break
      }
    })

    videoModalElement.addEventListener('hidden.bs.modal', event => {
      videoModalContentElement.innerHTML = ''      
    })
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleVideoModalEvents()
})